'use client';

import React from 'react';

const socials = [
  {
    platform: 'Instagram',
    handle: '@riograndepropertysolutions',
    desc: 'See our newest transformations, before & after photos, customer projects, and exterior cleaning tips.',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    href: 'https://www.instagram.com/riograndepropertysolutions',
    btnText: 'Follow on Instagram',
    iconBg: 'bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400',
    btnBg: 'bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 hover:opacity-90',
  },
  {
    platform: 'Facebook',
    handle: 'Rio Grande Property Solutions',
    desc: 'Stay up to date with company news, completed jobs, customer reviews, and special offers.',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    href: 'https://www.facebook.com/riograndepropertysolutions',
    btnText: 'Visit Facebook',
    iconBg: 'bg-gradient-to-br from-blue-600 to-blue-800',
    btnBg: 'bg-gradient-to-br from-blue-600 to-blue-800 hover:opacity-90',
  },
  {
    platform: 'TikTok',
    handle: '@rgps505',
    desc: 'Watch satisfying pressure washing videos, cleaning transformations, and behind-the-scenes content.',
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
      </svg>
    ),
    href: 'https://www.tiktok.com/@rgps505',
    btnText: 'Watch on TikTok',
    iconBg: 'bg-gradient-to-br from-slate-900 to-slate-700',
    btnBg: 'bg-gradient-to-br from-slate-900 to-slate-700 hover:opacity-90',
  },
];

export default function RGPSSocial() {
  return (
    <section className="bg-white py-24 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-600 font-bold text-sm px-4 py-2 rounded-full mb-4 border border-teal-100">
            Follow Our Work
          </div>
          <h2
            className="text-gray-900 font-bold mb-4"
            style={{ fontSize: 'clamp(1.75rem, 4vw, 2.75rem)', fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Follow Our Latest Projects
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Stay connected and see our work in action. Follow us on social media for real transformations, tips, and updates.
          </p>
        </div>

        {/* Social Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {socials?.map((s) => (
            <div
              key={s?.platform}
              className="flex flex-col items-center text-center bg-white rounded-3xl p-8 border border-gray-100"
              style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}
            >
              {/* Icon */}
              <div className={`${s?.iconBg} w-20 h-20 rounded-2xl flex items-center justify-center text-white mb-5 shadow-md`}>
                {s?.icon}
              </div>

              {/* Platform name */}
              <h3 className="text-gray-900 font-bold text-xl mb-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                {s?.platform}
              </h3>

              {/* Handle */}
              <p className="text-gray-400 text-sm font-medium mb-4">{s?.handle}</p>

              {/* Description */}
              <p className="text-gray-500 text-sm leading-relaxed mb-7 flex-1">{s?.desc}</p>

              {/* Button */}
              <a
                href={s?.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`${s?.btnBg} w-full flex items-center justify-center text-white font-bold text-sm py-3.5 px-6 rounded-xl transition-all shadow-sm`}
              >
                {s?.btnText}
              </a>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
